import comp from "./QuestionLibrarySelectedFeed";
export default comp;
